export const messages = {
  en: {
    couponPropertyPoolManage: {
      search: {
        title: 'Search Conditions',
        cppId: 'Coupon ID',
        couponName: 'Coupon Name',
        fromType: 'From Type',
        toType: 'To Type'
      },
      list: {
        title: 'Coupon List',
        add: 'Create'
      },
      table: {
        cppId: 'ID',
        couponName: 'Coupon Name',
        fromType: 'From Type',
        toType: 'To Type',
        stock: 'Quantity',
        validityDay: 'Validity',
        day: 'days',
        createTime: 'Create Time',
        gift: 'Manual Gift'
      },
      fromType: {
        market: 'Market Purchase',
        self: 'Self Made'
      },
      toType: {
        shopping: 'Shopping',
        payment: 'Payment',
        repair: 'Repair',
        parking: 'Parking',
        charging: 'Charging'
      },
      add: {
        title: 'Create Coupon',
        couponName: 'Coupon Name',
        couponNamePlaceholder: 'Required, please enter coupon name',
        toType: 'Purpose',
        toTypePlaceholder: 'Required, please select purpose',
        stock: 'Quantity',
        stockPlaceholder: 'Required, please enter quantity',
        validityDay: 'Validity',
        validityDayPlaceholder: 'Required, please enter validity (days)',
        remark: 'Instructions',
        remarkPlaceholder: 'Required, please enter instructions',
        success: 'Create successfully',
        error: 'Create failed'
      },
      edit: {
        title: 'Edit Coupon',
        couponName: 'Coupon Name',
        couponNamePlaceholder: 'Required, please enter coupon name',
        toType: 'Purpose',
        toTypePlaceholder: 'Required, please select purpose',
        stock: 'Quantity',
        stockPlaceholder: 'Required, please enter quantity',
        validityDay: 'Validity',
        validityDayPlaceholder: 'Required, please enter validity (days)',
        remark: 'Instructions',
        remarkPlaceholder: 'Required, please enter instructions',
        success: 'Edit successfully',
        error: 'Edit failed'
      },
      gift: {
        title: 'Gift Coupon',
        couponName: 'Coupon Name',
        giftCount: 'Quantity',
        giftCountPlaceholder: 'Required, please enter quantity',
        tel: 'Owner Phone',
        telPlaceholder: 'Required, please enter phone number',
        submit: 'Gift',
        success: 'Gift successfully',
        error: 'Gift failed'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this coupon?',
        success: 'Delete successfully',
        error: 'Delete failed'
      },
      validate: {
        couponNameRequired: 'Coupon name is required',
        couponNameMaxLength: 'Coupon name cannot exceed 64 characters',
        toTypeRequired: 'Purpose is required',
        stockRequired: 'Quantity is required',
        validityDayRequired: 'Validity is required',
        remarkRequired: 'Instructions is required',
        cppIdRequired: 'Coupon ID is required',
        giftCountRequired: 'Quantity is required',
        telRequired: 'Phone number is required'
      },
      fetchError: 'Failed to get coupon list'
    }
  },
  zh: {
    couponPropertyPoolManage: {
      search: {
        title: '查询条件',
        cppId: '优惠券编号',
        couponName: '优惠券名称',
        fromType: '来自方式',
        toType: '用途'
      },
      list: {
        title: '优惠券列表',
        add: '制作'
      },
      table: {
        cppId: '编号',
        couponName: '优惠券名称',
        fromType: '来自方式',
        toType: '用途',
        stock: '数量',
        validityDay: '有效期',
        day: '天',
        createTime: '创建时间',
        gift: '手工赠送'
      },
      fromType: {
        market: '优惠券市场购买',
        self: '自己制作'
      },
      toType: {
        shopping: '购物',
        payment: '缴费',
        repair: '维修劵',
        parking: '停车劵',
        charging: '充电桩充电劵'
      },
      add: {
        title: '制作优惠券',
        couponName: '优惠券名称',
        couponNamePlaceholder: '必填，请填写优惠券名称',
        toType: '用途',
        toTypePlaceholder: '必填，请选择用途',
        stock: '数量',
        stockPlaceholder: '必填，请填写数量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，请填写有效期(天)',
        remark: '使用说明',
        remarkPlaceholder: '必填，请填写使用说明',
        success: '制作成功',
        error: '制作失败'
      },
      edit: {
        title: '修改优惠券',
        couponName: '优惠券名称',
        couponNamePlaceholder: '必填，请填写优惠券名称',
        toType: '用途',
        toTypePlaceholder: '必填，请选择用途',
        stock: '数量',
        stockPlaceholder: '必填，请填写数量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，请填写有效期(天)',
        remark: '使用说明',
        remarkPlaceholder: '必填，请填写使用说明',
        success: '修改成功',
        error: '修改失败'
      },
      gift: {
        title: '赠送优惠券',
        couponName: '优惠券名称',
        giftCount: '数量',
        giftCountPlaceholder: '必填，请填写数量',
        tel: '业主手机号',
        telPlaceholder: '必填，请填写手机号',
        submit: '赠送',
        success: '赠送成功',
        error: '赠送失败'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除优惠券?',
        success: '删除成功',
        error: '删除失败'
      },
      validate: {
        couponNameRequired: '优惠券名称不能为空',
        couponNameMaxLength: '优惠券名称不能超过64个字符',
        toTypeRequired: '用途不能为空',
        stockRequired: '数量不能为空',
        validityDayRequired: '有效期不能为空',
        remarkRequired: '使用说明不能为空',
        cppIdRequired: '优惠券编号不能为空',
        giftCountRequired: '数量不能为空',
        telRequired: '手机号不能为空'
      },
fetchError: '獲取優惠券列表失敗'
    }
  },
  'zh-TW': {
    couponPropertyPoolManage: {
      search: {
        title: '查詢條件',
        cppId: '優惠券編號',
        couponName: '優惠券名稱',
        fromType: '來自方式',
        toType: '用途'
      },
      list: {
        title: '優惠券列表',
        add: '製作'
      },
      table: {
        cppId: '編號',
        couponName: '優惠券名稱',
        fromType: '來自方式',
        toType: '用途',
        stock: '數量',
        validityDay: '有效期',
        day: '天',
        createTime: '創建時間',
        gift: '手工贈送'
      },
      fromType: {
        market: '優惠券市場購買',
        self: '自己製作'
      },
      toType: {
        shopping: '購物',
        payment: '繳費',
        repair: '維修劵',
        parking: '停車劵',
        charging: '充電樁充電劵'
      },
      add: {
        title: '製作優惠券',
        couponName: '優惠券名稱',
        couponNamePlaceholder: '必填，請填寫優惠券名稱',
        toType: '用途',
        toTypePlaceholder: '必填，請選擇用途',
        stock: '數量',
        stockPlaceholder: '必填，請填寫數量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，請填寫有效期(天)',
        remark: '使用說明',
        remarkPlaceholder: '必填，請填寫使用說明',
        success: '製作成功',
        error: '製作失敗'
      },
      edit: {
        title: '修改優惠券',
        couponName: '優惠券名稱',
        couponNamePlaceholder: '必填，請填寫優惠券名稱',
        toType: '用途',
        toTypePlaceholder: '必填，請選擇用途',
        stock: '數量',
        stockPlaceholder: '必填，請填寫數量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，請填寫有效期(天)',
        remark: '使用說明',
        remarkPlaceholder: '必填，請填寫使用說明',
        success: '修改成功',
        error: '修改失敗'
      },
      gift: {
        title: '贈送優惠券',
        couponName: '優惠券名稱',
        giftCount: '數量',
        giftCountPlaceholder: '必填，請填寫數量',
        tel: '業主手機號',
        telPlaceholder: '必填，請填寫手機號',
        submit: '贈送',
        success: '贈送成功',
        error: '贈送失敗'
      },
      delete: {
        title: '刪除確認',
        confirmText: '確定刪除優惠券?',
        success: '刪除成功',
        error: '刪除失敗'
      },
      validate: {
        couponNameRequired: '優惠券名稱不能為空',
        couponNameMaxLength: '優惠券名稱不能超過64個字符',
        toTypeRequired: '用途不能為空',
        stockRequired: '數量不能為空',
        validityDayRequired: '有效期不能為空',
        remarkRequired: '使用說明不能為空',
        cppIdRequired: '優惠券編號不能為空',
        giftCountRequired: '數量不能為空',
        telRequired: '手機號不能為空'
      },
      fetchError: '獲取優惠券列表失敗'
    }
  }
}